import { useEffect } from "react";
import { useGetFiling } from "./api/useGetFiling";
import { useResetHash } from "@/shared/hooks/useResetHash";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import ScrollableTextWithHighlighting from "@/shared/components/scrollable-text-highlighting/ScrollableTextWithHighlighting";

interface ViewFilingModalProps {
  id: string | null;
  chunkId?: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function ViewFilingModal({
  id,
  chunkId,
  open,
  onOpenChange,
}: ViewFilingModalProps) {
  const { filing, getFiling, isLoading } = useGetFiling();

  useEffect(() => {
    if (open && id) {
      getFiling(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, chunkId, open]);

  useResetHash(filing);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl h-[80vh]">
        <DialogHeader>
          <DialogTitle>{filing?.title || "Filing Details"}</DialogTitle>
          {!isLoading && filing && (
            <a
              href={filing.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              Open the filing on EDGAR
            </a>
          )}
        </DialogHeader>
        <div className="flex-1 overflow-y-auto">
          {isLoading && (
            <div className="flex items-start justify-center pt-4">
              <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
            </div>
          )}
          {filing?.fullText && (
            <ScrollableTextWithHighlighting fullText={filing.fullText} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
